const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"] + "&width=800";
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720]
	);
	newImage.loading = "lazy";
	return newImage;
};

const checkSwatches = () => {
	document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
		wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
			input.addEventListener("click", (event) => {
				const primaryImage = wrapper.querySelector(".media--first");
				const secondaryImage = wrapper.querySelector(".media--second");
				const handleProduct = wrapper.dataset.product;

				if (event.currentTarget.checked && primaryImage) {
					const swatchLink = wrapper.querySelector(".js-color-swatches-link");
					const variantLink = event.currentTarget.dataset.productUrl
						|| event.currentTarget.dataset.variantLink;

					if (swatchLink && variantLink) {
						swatchLink.setAttribute("href", variantLink);
					}

					const featuredMediaJson = event.currentTarget.dataset.featuredMedia;
					const currentColor = event.currentTarget.value;

					const swapPrimaryImage = (featuredMedia, productTitle) => {
						if (!featuredMedia) return;

						const newPrimaryImage = createImageElement(
							featuredMedia,
							primaryImage.className,
							primaryImage.sizes,
							productTitle
						);

						if (newPrimaryImage.src === primaryImage.src) return;

						let flag = false;
						if (secondaryImage) {
							const secondaryImagePathname = new URL(secondaryImage.src).pathname;
							const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

							if (secondaryImagePathname == newPrimaryImagePathname) {
								primaryImage.remove();
								secondaryImage.classList.remove("media--second");
								secondaryImage.classList.add("media--first");
								flag = true;
							}
						}
						if (flag == false) {
							primaryImage.animate(
								{ opacity: [1, 0] },
								{ duration: 200, easing: "ease-in", fill: "forwards" }
							).finished;
							setTimeout(function () {
								primaryImage.replaceWith(newPrimaryImage);
								newPrimaryImage.animate(
									{ opacity: [0, 1] },
									{ duration: 200, easing: "ease-in" }
								);
								if (secondaryImage) {
									secondaryImage.remove();
								}
							}, 200);
						}
					};

					if (featuredMediaJson) {
						try {
							swapPrimaryImage(
								JSON.parse(featuredMediaJson),
								wrapper.dataset.productTitle || ""
							);
						} catch (error) {
							console.warn("Invalid featured media data on swatch input", error);
						}
						return;
					}

					jQuery.getJSON(
						window.Shopify.routes.root + `products/${handleProduct}.js`,
						function (product) {
							const variant = product.variants.filter(
								(item) =>
									item.featured_media != null &&
									item.options.includes(currentColor)
							)[0];
							swapPrimaryImage(variant?.featured_media, product.title);
						}
					);
				}
			});
		});
	});
};

function colorSwatches() {
	checkSwatches();

	document.addEventListener("shopify:section:load", function () {
		checkSwatches();
	});
}

(function () {
	colorSwatches();
})();
